// extracted by mini-css-extract-plugin
module.exports = {"table":"Leaderboard_table__5tkq-","myRow":"Leaderboard_myRow__3ZU2s"};